import { FC } from 'react';
import './Header.scss';
import Logo from '_assets/consolidocs-text.png';
import subLogo from '_assets/logo-purple.png';
import {
  LogoHeader,
  NotificationCenter,
  useSignOut,
  Version,
} from '@consolidocs-ui/components';
import { useNavigate } from 'react-router';
import uppy from '../../../lib/uppyInstance';
import DepartmentSelector from '../DepartmentSelector';
import { default as useUserPermissions } from '@consolidocs-ui/hooks/useUserPermissions';
import {
  useGetProfilePictureQuery,
  useVersionTestQuery,
} from '@consolidocs-ui/data-access/UserApi';
import { useAiVersionTestQuery } from '@consolidocs-ui/data-access/AIServiceApi';

const Header: FC = () => {
  const { signOut } = useSignOut();
  const navigate = useNavigate();
  const { roles, selectedRoleKey } = useUserPermissions();

  const { data: profilePictureData } = useGetProfilePictureQuery();
  const profilePictureUrl = profilePictureData?.data?.url;

  const { data: backendVersion } = useVersionTestQuery('');
  const { data: aiServiceVersion } = useAiVersionTestQuery();

  const handleLogout = async () => {
    uppy.clear();
    await signOut();
  };

  const handleProfileClick = () => {
    navigate('/profile');
  };

  // Get the selected role information for display in profile menu
  const selectedRole = roles?.find(
    (role) => `${role.role_id}/${role.department_id}` === selectedRoleKey
  );

  const selectedRoleInfo = selectedRole
    ? {
        department: selectedRole.department,
        role: selectedRole.role,
        jobRole:
          selectedRole.job_role_data?.name ||
          selectedRole.job_role ||
          undefined,
      }
    : undefined;

  return (
    <LogoHeader
      Logo={Logo}
      subLogo={subLogo}
      onLogout={handleLogout}
      onProfileClick={handleProfileClick}
      departmentSelectSlot={<DepartmentSelector />}
      notificationSlot={<NotificationCenter />}
      centerSlot={
        <Version
          variant="inline"
          backendVersion={backendVersion?.data?.version_info?.commit_id}
          aiServiceVersion={aiServiceVersion?.data?.version_info?.commit_id}
        />
      }
      selectedRole={selectedRoleInfo}
      profilePicture={profilePictureUrl}
    />
  );
};

export default Header;
